import { useState, useEffect } from "react";
import { BASENAME } from "../router/constants";

const LanguageContext = React.createContext("en");

function LanguageProvider({ children, defaultLanguage }) {
  const [language, setLanguage] = useState(
    defaultLanguage === "default" ? "en" : defaultLanguage
  );
  useEffect(() => {
    let slug = window.location.pathname;
    if (slug.startsWith(`/${BASENAME}`)) {
      updateLanguage("en");
    } else if (slug.startsWith("/global-settings")) {
      updateLanguage("en");
    } else {
      const parts = slug.split("/").filter((p) => {
        return p ? true : false;
      });
      updateLanguage(parts[0]);
    }
  }, []);

  function updateLanguage(lang) {
    if (language !== lang) {
      setLanguage(lang);
    }
  }

  return (
    <LanguageContext.Provider value={language}>
      {children}
    </LanguageContext.Provider>
  );
}

export default LanguageProvider;
export { LanguageContext };
